module.exports = __webpack_public_path__ + "img/pw.b1b9266f.svg";